import { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import { IconContext } from "react-icons";
import { FaSpinner } from "react-icons/fa";
import Gallery from "../Gallery";
import DashboardHeader from "~/components/DashboardHeader";
import BackToTop from "~/components/Button/BackToTop";
import Container from "../styles";
import api from "~/adapters/api";

type SharedGalleryViewPageProps = {
    token: string;
};

const SharedGalleryViewPage = ({ token }: SharedGalleryViewPageProps) => {
    const [loading, setLoading] = useState(false);
    const [job, setJob] = useState(null);
    const [coverThumb, setCoverThumb] = useState("");
    const [photos, setPhotos] = useState([]);

    const getGallery = useCallback(() => {
        setLoading(true);
        api.jobs.galleries.getByToken({ token })
            .then((res: Record<string, any>) => {
                const { record } = res;
                setJob(record);
                setPhotos(record.customerFiles);

                const coverFile = record.customerFiles.find(file => file.cover);
                if (coverFile) {
                    setCoverThumb(coverFile.thumb);
                } else {
                    setCoverThumb(record?.customerFiles?.[0]?.thumb ?? "");
                }
            })
            .catch(e => {
                toast.error(`Não foi possível recuperar galeria: ${e?.response?.data?.msg ?? e.message}`);
            })
            .finally(() => setLoading(false))
    }, [token]);

    useEffect(() => {
        if (!token) {
            setJob(null);
            return;
        }

        getGallery();
    }, [token, getGallery]);

    if (loading) {
        return (
            <div className="mt-30 pr-30 pl-30 nt-20 text-center">
                <IconContext.Provider value={{ size: "22px", className: "spin" }}>
                    <FaSpinner />
                </IconContext.Provider>
            </div>
        );
    }

    if (!loading && !job) {
        return (
            <Container>
                <DashboardHeader hideMenu hideUser />
                <div className="mt-30 pr-30 pl-30 nt-20 text-center">
                    <p>Não encontrado</p>
                </div>
            </Container>
        );
    }

    return (
        <>
            <Gallery job={job} photos={photos} cover={coverThumb} token={token} hideControls />
            <BackToTop />
        </>
    );
};

export default SharedGalleryViewPage;
